import "core-js/modules/es.array.iterator.js";
import React from 'react';
import { Button } from '@isyc-react/form/modules/base/button';
import { base64ToDataUrl, blobToFile, textToBlob, dataUrlToFile, getArchiveIcon, ViewArchive } from '@isyc-react/archives';
import { ExportTableModal } from "./export-modal/export-modal.component";
import { InputRange } from '@isyc-react/form/modules/input/range';
import { Tabs } from '@isyc-react/animation/modules/slider/tabs';
import clsx from 'clsx';
import { InputCheckbox } from '@isyc-react/form/modules/input/option/checkbox';
import { ExportPdf } from "./pdf";
import { utils, write } from '@isyc-react/archives/export/excel';
import { useTranslation } from 'react-i18next';
import { nstable } from "../../../i18n/namespaces";
import "./export-table.style.scss";
const dataToExcelFile = (type, data, name) => {
  const workbook = utils.book_new();
  const sheet = utils.aoa_to_sheet(data);
  utils.book_append_sheet(workbook, sheet, 'Exported table');

  // TYPES: "string" | "base64" | "binary" | "buffer" | "file" | "array"
  const base64 = write(workbook, {
    bookType: type,
    bookSST: true,
    type: 'base64'
  });
  const file = dataUrlToFile(base64ToDataUrl(base64, 'application/vnd.ms-excel'), name);
  return file;
};
const dataToCsvFile = (data, name) => {
  const workbook = utils.book_new();
  const sheet = utils.aoa_to_sheet(data);
  utils.book_append_sheet(workbook, sheet, 'Exported table');
  const csv = utils.sheet_to_csv(sheet); // TODO pass all options ...

  const mime = 'text/csv';
  const file = blobToFile(textToBlob(csv, mime), name, mime);
  return file;
};

// tableau('biff8', 'SheetJSTableExport.xls');
// tableau('ods',   'SheetJSTableExport.ods');
// tableau('fods',  'SheetJSTableExport.fods');
// tableau('xlml',  'SheetJSTableExport.xml');
// tableau('xlsb',  'SheetJSTableExport.xlsb');
// tableau('xlsx',  'SheetJSTableExport.xlsx');
// TYPES: "xlsx" (OK) | "xlsm" | "xlsb" | "xls" (OK) | "xla" | "biff8" | "biff5" | "biff2" |
// "xlml" (OK) | "ods" (OK) | "fods" (OK) | "csv" | "txt" | "sylk" | "slk" | "html" | "dif" | "rtf" | "prn" | "eth" | "dbf"
const TabHeader = props => {
  const {
    ext,
    children
  } = props;
  const classes = React.useMemo(() => getArchiveIcon(`.${ext}`), [ext]);
  return /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center justify-content-center"
  }, /*#__PURE__*/React.createElement("i", {
    className: clsx(classes.icon, 'font-size-26 me-2')
  }), /*#__PURE__*/React.createElement("div", null, children));
};

// TODO ADD NAME OPTION INPUT TEXT
// TODO añadir columnas visibles ?
// TODO añadir las options que tenga cada uno para exportar (xlsx options etc) a lo suyo
// TODO export to libre office types
// TODO export to txt type

// TODO change exportableHeaders, when isVisible is changed does not trigger re render

// TODO i18n
export const ExportButton = props => {
  const {
    instance
  } = props;
  const {
    allColumns,
    visibleColumns,
    preFilteredRows,
    page,
    flatRows
  } = instance;
  const {
    t
  } = useTranslation(nstable.common);

  // console.log('INSTANCE: ', instance)
  // sortedFlatRows

  // TODO initial to false
  const [show, setShow] = React.useState(false);
  const [range, setRange] = React.useState({
    min: 0,
    max: preFilteredRows.length
  }); // page.length

  const [tab, setTab] = React.useState(0);
  const [filters, setFilters] = React.useState({
    checked: true
  });
  // TODO set loading while creating blob ?
  const [file, setFile] = React.useState(null);
  const exportableColHeaders = React.useMemo(() => {
    const headers = [];
    visibleColumns.forEach(col => {
      if (col.export && col.isVisible) {
        headers.push(col.export.header);
      }
    });
    return headers;
  }, [visibleColumns]);
  const currentRows = React.useMemo(() => filters.checked ? flatRows : preFilteredRows, [filters, preFilteredRows, flatRows]);

  // TODO When fetching -> range should be just page size, and total and filter is not based on filteredRows and totalRows length
  // just like in pagination
  // TODO take care of flatRows and preFilteredRows -> SHOULD BE LIKE THIS (make destructuring with alias or something?)
  // and replace all ocurrences
  // const filteredRows = preGroupedRows
  // const totalRows = preFilteredRows

  React.useEffect(() => {
    setRange({
      min: 0,
      max: currentRows.length
    });
  }, [currentRows, filters]);

  // const filteredCount = filteredCountProp ?? preGroupedRows?.length
  // const totalCount = totalCountProp ?? preFilteredRows?.length

  return /*#__PURE__*/React.createElement(React.Fragment, null, exportableColHeaders.length > 0 && /*#__PURE__*/React.createElement(Button, {
    onClick: () => setShow(true),
    className: "btn btn-outline-primary d-flex align-items-center"
  }, /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-export-variant"
  }), /*#__PURE__*/React.createElement("div", {
    className: "ms-2"
  }, t('table.controls.export.button'))), /*#__PURE__*/React.createElement(ExportTableModal, {
    show: show,
    onHide: () => setShow(false)
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h4", null, "Export info"), /*#__PURE__*/React.createElement("div", {
    className: "mb-2"
  }, exportableColHeaders.length === 0 ? /*#__PURE__*/React.createElement("div", null, "No hay columnas definidas como exportables en esta tabla") : /*#__PURE__*/React.createElement("div", {
    className: "d-flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: "me-2"
  }, "Columnas exportables"), /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center flex-wrap"
  }, exportableColHeaders.map((colHeader, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    className: "badge bg-primary mx-1"
  }, colHeader))))), /*#__PURE__*/React.createElement("h4", null, "Export config"), /*#__PURE__*/React.createElement("div", {
    className: "my-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-3",
    style: {
      maxWidth: '500px'
    }
  }, /*#__PURE__*/React.createElement(InputRange, {
    minValue: 0,
    maxValue: currentRows.length,
    value: range,
    onChange: v => setRange(v)
  })), /*#__PURE__*/React.createElement("div", null, "Se exportar\xE1n ", range.max - range.min, " elementos, del [", range.min, " - ", range.max, "] de un total de", ' ', preFilteredRows.length, " elementos", preFilteredRows.length !== flatRows.length && /*#__PURE__*/React.createElement(React.Fragment, null, " (hay filtros activos)"))), /*#__PURE__*/React.createElement("div", {
    className: "my-3"
  }, /*#__PURE__*/React.createElement(InputCheckbox, {
    value: filters,
    onChange: setFilters
  }, "Usar los filtros/ordenaciones activos en la tabla")), /*#__PURE__*/React.createElement("div", {
    className: "export-table-tabs-container card border p-1 mt-4"
  }, /*#__PURE__*/React.createElement(Tabs, {
    current: tab,
    onChange: setTab,
    className: "export-table-type-tabs",
    slideAnimation: false,
    tabs: [{
      header: /*#__PURE__*/React.createElement(TabHeader, {
        ext: "pdf"
      }, "Pdf"),
      content: () => /*#__PURE__*/React.createElement(ExportPdf, {
        allColumns: allColumns,
        currentRows: currentRows,
        range: range,
        onFile: setFile
      })
    }, {
      header: /*#__PURE__*/React.createElement(TabHeader, {
        ext: "xlsx"
      }, "Excel"),
      content: () => {
        return /*#__PURE__*/React.createElement("div", {
          className: "info w-100"
        }, "EXCEL", /*#__PURE__*/React.createElement(Button, {
          className: "btn btn-primary",
          onClick: () => {
            const data = [[...exportableColHeaders]];
            const dataRows = currentRows.filter(row => !row.isGrouped).slice(range.min, range.max).map(row => {
              const cells = [];
              // console.log('ROW: ',row)
              allColumns.forEach(col => {
                if (col.export && col.isVisible) {
                  cells.push(col.export.cell(row.original));
                }
              });
              return cells;
            });
            data.push(...dataRows);
            console.log('DATA ROWS: ', data);
            const excelFile = dataToExcelFile('xlsx', data, 'test_sample.xlsx');
            console.log('EXCEL FILE: ', excelFile);
            setFile(excelFile);
          }
        }, "Crear EXCEL"));
      }
    }, {
      header: /*#__PURE__*/React.createElement(TabHeader, {
        ext: "csv"
      }, "Csv"),
      content: () => {
        return /*#__PURE__*/React.createElement("div", {
          className: "info w-100"
        }, "CSV", /*#__PURE__*/React.createElement(Button, {
          className: "btn btn-primary",
          onClick: () => {
            const data = [[...exportableColHeaders]];
            const dataRows = currentRows.filter(row => !row.isGrouped).slice(range.min, range.max).map(row => {
              const cells = [];
              // console.log('ROW: ',row)
              allColumns.forEach(col => {
                if (col.export && col.isVisible) {
                  cells.push(col.export.cell(row.original));
                }
              });
              return cells;
            });
            data.push(...dataRows);
            console.log('DATA ROWS: ', data);
            const csvFile = dataToCsvFile(data, 'test_sample.csv');
            console.log('CSV FILE: ', csvFile);
            setFile(csvFile);
          }
        }, "Crear CSV"));
      }
    }, {
      header: /*#__PURE__*/React.createElement(TabHeader, {
        ext: "ods"
      }, "Libre office"),
      content: () => {
        return /*#__PURE__*/React.createElement("div", {
          className: "info w-100"
        }, "ODS Libre office (elegir ods, fods, rtf)", /*#__PURE__*/React.createElement(Button, {
          className: "btn btn-primary",
          onClick: () => {
            const data = [[...exportableColHeaders]];
            const dataRows = currentRows.filter(row => !row.isGrouped).slice(range.min, range.max).map(row => {
              const cells = [];
              // console.log('ROW: ',row)
              allColumns.forEach(col => {
                if (col.export && col.isVisible) {
                  cells.push(col.export.cell(row.original));
                }
              });
              return cells;
            });
            data.push(...dataRows);
            console.log('DATA ROWS: ', data);

            // const csvFile = dataToCsvFile(data, 'test_sample.csv')
            // console.log('CSV FILE: ', csvFile)
            // setFile(csvFile)
          }
        }, "Crear ODS"));
      }
    }]
  })), file && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h4", null, "Export preview"), /*#__PURE__*/React.createElement(ViewArchive, {
    archive: {
      file
    }
  })))));
};